import { useProjectStore } from '@/store/projectStore';
import { useOnboardingStore } from '@/store/onboardingStore';
import { chatStore } from '@/storage/projectStorePort';
import { withKind } from '@/onboarding/runBuild';
import type { AppDefinition } from '@/types/app';

export async function finalizeBuild(
  appName: string,
  goal: string,
  definition: AppDefinition,
  summary: string,
): Promise<{ projectId: string }> {
  const kind = useOnboardingStore.getState().kind;
  const project = await useProjectStore.getState().createFromDefinition(appName, goal, withKind(definition, kind));
  const now = new Date().toISOString();
  await chatStore().addMessage(project.id, { role: 'user', content: goal, timestamp: now });
  await chatStore().addMessage(project.id, {
    role: 'assistant',
    content: summary || `I built **${appName}** for you. Tell me what to change and I'll update it.`,
    timestamp: new Date().toISOString(),
    appDefinitionSnapshot: JSON.stringify(definition),
  });
  return { projectId: project.id };
}
